import api from './api';

const teamGranularService = {
  async list() {
    const response = await api.get('/partners/team-granular');
    return response.data;
  },

  async getPresets() {
    const response = await api.get('/partners/team-granular/presets');
    return response.data;
  },

  async invite(data) {
    const response = await api.post('/partners/team-granular', data);
    return response.data;
  },

  async update(memberId, data) {
    const response = await api.put(`/partners/team-granular/${memberId}`, data);
    return response.data;
  },

  async remove(memberId) {
    const response = await api.delete(`/partners/team-granular/${memberId}`);
    return response.data;
  },

  async resend(memberId) {
    const response = await api.post(`/partners/team-granular/${memberId}/resend`);
    return response.data;
  },

  async resolveByToken(token) {
    // Endpoint publico (sin auth requerido)
    const response = await api.get(`/partners/team-invite/${token}`);
    return response.data;
  },

  async acceptInvite(token, payload = {}) {
    // Endpoint publico con optionalAuth — si hay sesion la usa
    const response = await api.post(`/partners/team-invite/${token}/accept`, payload);
    return response.data;
  },

  async getMySession() {
    const response = await api.get('/partners/me/session');
    return response.data;
  }
};

export default teamGranularService;
